var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Modal',{attrs:{"title":"操作日志","width":"1000px","value":_vm.value},on:{"on-cancel":_vm.cancel}},[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.tableBody_item}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }